export * from './oura-ready.types';
export * from './oura-heart.types';
export * from './oura-sleep.types';
export * from './oura-works.types';
export * from './oura-tags.types';

export interface OuraApiResponseIntf<T> {
	data: T[],
	next_token: string;
}

export type OuraRecordLogType =
	| 'heart'
	| 'sleep'
// | 'ready'
// | 'works'
// | 'tags'


export type OuraRecordOnCallType =
	| 'getSleep'
	| 'getHeart'
	| 'getWorkouts'
	| 'getTags';


export type OuraMasterType = 'oura'